import {
  Card,
  CardHeader,
  CardContent,
  Stack,
  TextField,
  CardActions,
  Modal,
  FormControlLabel,
  Switch,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { branchSchema } from '../schemas/branchSchemas';
import { createBranch, resetBranchState } from '../store/branchActions';

BranchForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default function BranchForm({ open, onClose }) {
  const dispatch = useDispatch();
  const { isLoading, isSuccess } = useSelector((state) => state.branchReducer);

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess, onClose]);

  const onSubmit = async (values) => {
    dispatch(createBranch(values));
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, resetForm } = useFormik({
    initialValues: {
      name: '',
      code: '',
      country_code: '',
      is_active: true,
    },
    validationSchema: branchSchema,
    onSubmit,
    isSubmitting: isLoading,
  });

  const handleClose = () => {
    resetForm();
    dispatch(resetBranchState());
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '340px', md: '600px' },
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 24,
          p: { xs: '0px', md: '2px' },
          alignItems: 'center',
        }}
      >
        <form onSubmit={handleSubmit}>
          <CardHeader title="Add New Branch" />
          <CardContent>
            <Stack spacing={3}>
              <TextField
                fullWidth
                name="name"
                type="text"
                label="Branch Name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
              />

              <TextField
                fullWidth
                name="code"
                type="text"
                label="Branch Code"
                value={values.code}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.code && Boolean(errors.code)}
                helperText={touched.code && errors.code}
              />

              <FormControl fullWidth error={touched.country_code && Boolean(errors.country_code)}>
                <InputLabel>Country Code</InputLabel>
                <Select
                  name="country_code"
                  value={values.country_code}
                  label="Country Code"
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  <MenuItem value="254">Kenya (254)</MenuItem>
                  <MenuItem value="255">Uganda (255)</MenuItem>
                  <MenuItem value="256">Tanzania (256)</MenuItem>
                </Select>
                {touched.country_code && errors.country_code && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                    {errors.country_code}
                  </Typography>
                )}
              </FormControl>

              <FormControlLabel
                control={<Switch name="is_active" checked={values.is_active} onChange={handleChange} color="primary" />}
                label="Active Branch"
              />
            </Stack>
          </CardContent>
          <CardActions sx={{ p: 3, pt: 0 }}>
            <Stack direction="row" spacing={2} sx={{ width: '100%', justifyContent: 'flex-end' }}>
              <LoadingButton variant="outlined" onClick={handleClose} disabled={isLoading}>
                Cancel
              </LoadingButton>
              <LoadingButton type="submit" variant="contained" loading={isLoading} disabled={isSubmitting}>
                Create Branch
              </LoadingButton>
            </Stack>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}
